module.exports = __webpack_public_path__ + "static/media/orange_project.ce1b5a9e.svg";